import React, { useState } from 'react';
import { SearchIcon, XIcon } from 'lucide-react';
const PlayerStats = () => {
  const [adaptData, setAdaptData] = useState(false);
  const [activeStatTab, setActiveStatTab] = useState('scoring');
  const statCategories = {
    scoring: [{
      label: 'PTS/G',
      value: 21.2,
      abbr: 'PTS/G',
      percentile: 85
    }, {
      label: 'TS%',
      value: 57.7,
      abbr: 'TS%',
      percentile: 72
    }, {
      label: '2PM/G',
      value: 4.3,
      abbr: '2PM/G',
      percentile: 65
    }, {
      label: '2P%',
      value: 51.3,
      abbr: '2P%',
      percentile: 68
    }, {
      label: '2P rate',
      value: 53.2,
      abbr: '2P rate',
      percentile: 70
    }, {
      label: '3PM/G',
      value: 2.6,
      abbr: '3PM/G',
      percentile: 60
    }, {
      label: '3P%',
      value: 35.6,
      abbr: '3P%',
      percentile: 55
    }, {
      label: '3P rate',
      value: 46.8,
      abbr: '3P rate',
      percentile: 62
    }, {
      label: 'FTM/G',
      value: 4.8,
      abbr: 'FTM/G',
      percentile: 75
    }, {
      label: 'FT%',
      value: 78.2,
      abbr: 'FT%',
      percentile: 80
    }, {
      label: 'FT rate',
      value: 39.0,
      abbr: 'FT rate',
      percentile: 65
    }],
    playmaking: [{
      label: 'AST/G',
      value: 1.7,
      abbr: 'AST/G',
      percentile: 45
    }, {
      label: 'AST%',
      value: 7.9,
      abbr: 'AST%',
      percentile: 40
    }, {
      label: 'TO/G',
      value: 1.8,
      abbr: 'TO/G',
      percentile: 35
    }, {
      label: 'TO%',
      value: 8.4,
      abbr: 'TO%',
      percentile: 30
    }, {
      label: 'AST/TO',
      value: 0.9,
      abbr: 'AST/TO',
      percentile: 25
    }],
    stealing: [{
      label: 'STL/G',
      value: 1.2,
      abbr: 'STL/G',
      percentile: 65
    }, {
      label: 'STL%',
      value: 1.6,
      abbr: 'STL%',
      percentile: 60
    }, {
      label: 'BLK/G',
      value: 0.4,
      abbr: 'BLK/G',
      percentile: 30
    }, {
      label: 'BLK%',
      value: 0.8,
      abbr: 'BLK%',
      percentile: 25
    }],
    rebounding: [{
      label: 'DR/G',
      value: 3.0,
      abbr: 'DR/G',
      percentile: 55
    }, {
      label: 'DR%',
      value: 11.8,
      abbr: 'DR%',
      percentile: 50
    }, {
      label: 'OR/G',
      value: 1.4,
      abbr: 'OR/G',
      percentile: 60
    }, {
      label: 'OR%',
      value: 4.9,
      abbr: 'OR%',
      percentile: 55
    }, {
      label: 'TR/G',
      value: 4.4,
      abbr: 'TR/G',
      percentile: 58
    }, {
      label: 'TR%',
      value: 8.1,
      abbr: 'TR%',
      percentile: 52
    }]
  };
  // Function to determine bar color based on percentile
  const getPercentileColor = percentile => {
    if (percentile >= 70) return 'bg-emerald-600';
    if (percentile >= 40) return 'bg-amber-600';
    return 'bg-red-600';
  };
  const advancedStats = [{
    category: 'SCORING',
    stat: 'ORTG',
    value: 114.5
  }, {
    category: 'RIM PROT',
    stat: 'BLK_PCT',
    value: 3.2
  }, {
    category: 'DEF REB',
    stat: 'DEFREB_PCT',
    value: 24.3
  }, {
    category: 'OFFENSIVE REB',
    stat: 'OFFREB_PCT',
    value: 8.7
  }, {
    category: 'STEALING',
    stat: 'STL_PCT',
    value: 2.1
  }, {
    category: 'PLAYMAKING',
    stat: 'AST_PCT',
    value: 32.6
  }, {
    category: 'DEFENSIVE IMPACT',
    stat: 'DRTG',
    value: 105.8
  }, {
    category: 'OFFENSIVE VOLUME',
    stat: 'USAGE_PCT',
    value: 28.4
  }, {
    category: 'SHOOTING',
    stat: 'TS_PCT',
    value: 59.3
  }];
  const selectedFactors = ['2PT', '3PT', 'FT', 'SCORING', 'RIM PRO', 'STEALING'];
  const trendData = [{
    date: '11.01',
    item1: 380,
    item2: 250
  }, {
    date: '18.01',
    item1: 690,
    item2: 350
  }, {
    date: '25.01',
    item1: 610,
    item2: 140
  }, {
    date: '02.02',
    item1: 500,
    item2: 210
  }, {
    date: '09.02',
    item1: 700,
    item2: 190
  }, {
    date: '11.02',
    item1: 480,
    item2: 340
  }, {
    date: '18.02',
    item1: 690,
    item2: 140
  }, {
    date: '26.02',
    item1: 680,
    item2: 350
  }];
  const [trendItems, setTrendItems] = useState([{
    id: 1,
    label: 'Item 1',
    color: '#2563eb' // blue-600
  }, {
    id: 2,
    label: 'Item 2',
    color: '#dc2626' // red-600
  }]);
  return <div data-id="element-566">
      {/* First Row: Combined Radar and Advanced Stats */}
      <div className="mt-6 bg-white rounded-lg shadow-md" data-id="element-567">
        <div className="p-4 flex justify-between items-center border-b" data-id="element-568">
          <h3 className="font-bold text-gray-900" data-id="element-569">OUR STATS</h3>
          <div className="flex items-center space-x-4" data-id="element-570">
            <div className="flex items-center" data-id="element-571">
              <span className="text-sm mr-2 text-gray-600" data-id="element-572">ADAPT DATA</span>
              <div className={`w-10 h-5 rounded-full ${adaptData ? 'bg-blue-600' : 'bg-gray-300'} relative cursor-pointer`} onClick={() => setAdaptData(!adaptData)} data-id="element-573">
                <div className={`absolute w-4 h-4 bg-white rounded-full top-0.5 transition-transform ${adaptData ? 'transform translate-x-5' : 'translate-x-0.5'}`} data-id="element-574"></div>
              </div>
            </div>
            <div className="relative w-48" data-id="element-575">
              <input type="text" defaultValue="NBA" className="w-full pl-3 pr-8 py-1.5 border rounded-md text-sm text-gray-900" data-id="element-576" />
              <SearchIcon className="w-4 h-4 absolute right-3 top-1.5 text-gray-500" data-id="element-577" />
            </div>
          </div>
        </div>

        <div className="flex" data-id="element-578">
          {/* Radar Chart Section */}
          <div className="w-1/2 p-4 border-r" data-id="element-579">
            <h4 className="font-bold text-sm mb-3 text-gray-900" data-id="element-580">RADAR</h4>
            <div className="relative h-64 w-64 mx-auto" data-id="element-581">
              {/* Radar Chart */}
              <svg viewBox="0 0 180 180" className="w-full h-full bg-[fff] pt-[0px] pb-[0px] pl-[4px] pr-[4px] mt-[0px] mb-[0px]" data-id="element-582">
                {/* Pentagon shape */}
                <polygon points="90,9 171,67.5 139.5,162 40.5,162 9,67.5" fill="none" stroke="#ccc" strokeWidth="1" data-id="element-583" />
                <polygon points="90,36 144,76.5 121.5,135 58.5,135 36,76.5" fill="none" stroke="#ccc" strokeWidth="1" data-id="element-584" />
                <polygon points="90,63 117,85.5 103.5,108 76.5,108 63,85.5" fill="none" stroke="#ccc" strokeWidth="1" data-id="element-585" />
                {/* Axes */}
                <line x1="90" y1="9" x2="90" y2="162" stroke="#ccc" strokeWidth="1" data-id="element-586" />
                <line x1="9" y1="67.5" x2="171" y2="67.5" stroke="#ccc" strokeWidth="1" data-id="element-587" />
                <line x1="40.5" y1="162" x2="139.5" y2="162" stroke="#ccc" strokeWidth="1" data-id="element-588" />
                {/* Data polygon */}
                <polygon points="90,36 144,76.5 121.5,117 58.5,135 63,76.5" fill="rgba(75, 85, 99, 0.3)" stroke="#4B5563" strokeWidth="2" data-id="element-589" />
                {/* Labels */}
                <text x="90" y="4.5" textAnchor="middle" className="text-[10px] uppercase tracking-wider font-bold fill-gray-500" data-id="element-590">
                  Scoring
                </text>
                <text x="175.5" y="67.5" textAnchor="middle" transform="rotate(90, 175.5, 67.5)" className="text-[10px] uppercase tracking-wider font-bold fill-gray-500" style={{
                overflow: 'visible'
              }} data-id="element-591">
                  RIM PRO
                </text>
                <text x="139.5" y="175.5" textAnchor="middle" className="text-[10px] uppercase tracking-wider font-bold fill-gray-500" data-id="element-592">
                  2PT
                </text>
                <text x="40.5" y="175.5" textAnchor="middle" className="text-[10px] uppercase tracking-wider font-bold fill-gray-500" data-id="element-593">
                  3PT
                </text>
                <text x="4.5" y="67.5" textAnchor="end" className="text-[10px] uppercase tracking-wider font-bold fill-gray-500" data-id="element-594">
                  FT
                </text>
              </svg>
            </div>
            <div className="mt-4" data-id="element-595">
              <div className="relative" data-id="element-596">
                <input type="text" placeholder="Search factor to add" className="w-full pl-10 pr-4 py-2 border rounded-lg text-sm text-gray-900" data-id="element-597" />
                <SearchIcon className="w-4 h-4 absolute left-3 top-2.5 text-gray-500" data-id="element-598" />
              </div>
              <div className="flex flex-wrap gap-2 mt-3" data-id="element-599">
                {selectedFactors.map((factor, index) => <div key={index} className={`
                    px-3 py-1 text-[10px] uppercase tracking-wider font-bold rounded-full flex items-center
                    ${index === 5 ? 'bg-gray-200 text-gray-600' : 'bg-gray-900 text-white'}
                  `} data-id="element-600">
                    {factor}
                    <XIcon className="w-3 h-3 ml-1" data-id="element-601" />
                  </div>)}
              </div>
            </div>
          </div>

          {/* Advanced Stats Table Section */}
          <div className="w-1/2 p-4" data-id="element-602">
            <h4 className="font-bold text-sm mb-3 text-gray-900" data-id="element-603">
              ADVANCED STATS
            </h4>
            <div className="overflow-hidden" data-id="element-604">
              <table className="min-w-full" data-id="element-605">
                <thead data-id="element-606">
                  <tr className="border-b" data-id="element-607">
                    <th className="text-left py-2 text-[10px] uppercase tracking-wider font-bold text-gray-500" data-id="element-608">
                      CATEGORY
                    </th>
                    <th className="text-left py-2 text-[10px] uppercase tracking-wider font-bold text-gray-500" data-id="element-609">
                      STAT
                    </th>
                    <th className="text-right py-2 text-[10px] uppercase tracking-wider font-bold text-gray-500" data-id="element-610">
                      VALUE
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-611">
                  {advancedStats.map((stat, index) => {
                  // Generate random value between 0 and 100
                  const randomValue = Math.floor(Math.random() * 101);
                  // Determine color based on value
                  let barColor = 'bg-red-600';
                  if (randomValue >= 75) {
                    barColor = 'bg-emerald-600';
                  } else if (randomValue >= 30) {
                    barColor = 'bg-amber-600';
                  }
                  return <tr key={index} className={index % 2 === 0 ? 'bg-gray-50' : ''} data-id="element-612">
                        <td className="py-2 text-xs font-medium text-gray-900" data-id="element-613">
                          {stat.category}
                        </td>
                        <td className="py-2 text-xs text-gray-600" data-id="element-614">
                          <div className="flex items-center" data-id="element-615">
                            <div className="w-24 h-4 bg-gray-200 rounded-sm overflow-hidden" data-id="element-616">
                              <div className={`h-full ${barColor}`} style={{
                            width: `${randomValue}%`
                          }} data-id="element-617"></div>
                            </div>
                            <span className="ml-2 text-[10px] font-bold text-gray-600" data-id="element-618">
                              {randomValue}%
                            </span>
                          </div>
                        </td>
                        <td className="py-2 text-xs font-bold text-gray-900 text-right" data-id="element-619">
                          {stat.value}
                        </td>
                      </tr>;
                })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* Second Row: Four Stat Boxes */}
      <div className="grid grid-cols-4 gap-4 mt-6" data-id="element-620">
        {/* Scoring Box */}
        <div className="bg-white p-4 rounded-lg shadow-md" data-id="element-621">
          <h3 className="font-bold mb-3 text-sm border-b pb-2 text-gray-900" data-id="element-622">
            SCORING
          </h3>
          <div className="space-y-3 max-h-80 overflow-y-auto pr-1" data-id="element-623">
            {statCategories.scoring.map((stat, index) => <div key={index} className="flex flex-col" data-id="element-624">
                <div className="flex justify-between items-center text-xs mb-1" data-id="element-625">
                  <span className="font-medium text-gray-600" data-id="element-626">{stat.abbr}</span>
                  <span className="font-bold text-gray-900" data-id="element-627">{stat.value}</span>
                </div>
                <div className="w-full h-5 bg-gray-200 rounded-sm overflow-hidden" data-id="element-628">
                  <div className={`h-full ${getPercentileColor(stat.percentile)} flex items-center pl-2 text-white text-[10px] font-bold`} style={{
                width: `${stat.percentile}%`
              }} data-id="element-629">
                    {stat.percentile}%
                  </div>
                </div>
              </div>)}
          </div>
        </div>

        {/* Playmaking Box */}
        <div className="bg-white p-4 rounded-lg shadow-md" data-id="element-630">
          <h3 className="font-bold mb-3 text-sm border-b pb-2 text-gray-900" data-id="element-631">
            PLAYMAKING
          </h3>
          <div className="space-y-3 max-h-80 overflow-y-auto pr-1" data-id="element-632">
            {statCategories.playmaking.map((stat, index) => <div key={index} className="flex flex-col" data-id="element-633">
                <div className="flex justify-between items-center text-xs mb-1" data-id="element-634">
                  <span className="font-medium text-gray-600" data-id="element-635">{stat.abbr}</span>
                  <span className="font-bold text-gray-900" data-id="element-636">{stat.value}</span>
                </div>
                <div className="w-full h-5 bg-gray-200 rounded-sm overflow-hidden" data-id="element-637">
                  <div className={`h-full ${getPercentileColor(stat.percentile)} flex items-center pl-2 text-white text-[10px] font-bold`} style={{
                width: `${stat.percentile}%`
              }} data-id="element-638">
                    {stat.percentile}%
                  </div>
                </div>
              </div>)}
          </div>
        </div>

        {/* Stealing Box */}
        <div className="bg-white p-4 rounded-lg shadow-md" data-id="element-639">
          <h3 className="font-bold mb-3 text-sm border-b pb-2 text-gray-900" data-id="element-640">
            STEALING
          </h3>
          <div className="space-y-3 max-h-80 overflow-y-auto pr-1" data-id="element-641">
            {statCategories.stealing.map((stat, index) => <div key={index} className="flex flex-col" data-id="element-642">
                <div className="flex justify-between items-center text-xs mb-1" data-id="element-643">
                  <span className="font-medium text-gray-600" data-id="element-644">{stat.abbr}</span>
                  <span className="font-bold text-gray-900" data-id="element-645">{stat.value}</span>
                </div>
                <div className="w-full h-5 bg-gray-200 rounded-sm overflow-hidden" data-id="element-646">
                  <div className={`h-full ${getPercentileColor(stat.percentile)} flex items-center pl-2 text-white text-[10px] font-bold`} style={{
                width: `${stat.percentile}%`
              }} data-id="element-647">
                    {stat.percentile}%
                  </div>
                </div>
              </div>)}
          </div>
        </div>

        {/* Rebounding Box */}
        <div className="bg-white p-4 rounded-lg shadow-md" data-id="element-648">
          <h3 className="font-bold mb-3 text-sm border-b pb-2 text-gray-900" data-id="element-649">
            REBOUNDING
          </h3>
          <div className="space-y-3 max-h-80 overflow-y-auto pr-1" data-id="element-650">
            {statCategories.rebounding.map((stat, index) => <div key={index} className="flex flex-col" data-id="element-651">
                <div className="flex justify-between items-center text-xs mb-1" data-id="element-652">
                  <span className="font-medium text-gray-600" data-id="element-653">{stat.abbr}</span>
                  <span className="font-bold text-gray-900" data-id="element-654">{stat.value}</span>
                </div>
                <div className="w-full h-5 bg-gray-200 rounded-sm overflow-hidden" data-id="element-655">
                  <div className={`h-full ${getPercentileColor(stat.percentile)} flex items-center pl-2 text-white text-[10px] font-bold`} style={{
                width: `${stat.percentile}%`
              }} data-id="element-656">
                    {stat.percentile}%
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </div>

      {/* Trend Section */}
      <div className="mt-6 bg-white p-6 rounded-lg shadow-md" data-id="element-657">
        <h3 className="font-bold mb-4 text-gray-900" data-id="element-658">TREND</h3>
        <div className="flex flex-col mb-4" data-id="element-659">
          <div className="relative mb-3" data-id="element-660">
            <input type="text" placeholder="Search trends to add" className="w-full pl-8 pr-4 py-1.5 border rounded-lg text-sm text-gray-900" data-id="element-661" />
            <SearchIcon className="w-4 h-4 absolute left-2.5 top-1.5 text-gray-500" data-id="element-662" />
          </div>
          <div className="flex flex-wrap gap-2" data-id="element-663">
            {trendItems.map(item => <div key={item.id} className="flex items-center px-3 py-1 rounded-full text-white text-[10px] uppercase tracking-wider font-bold" style={{
            backgroundColor: item.color
          }} data-id="element-664">
                {item.label}
                <XIcon className="w-3 h-3 ml-1.5 cursor-pointer" onClick={() => setTrendItems(items => items.filter(i => i.id !== item.id))} data-id="element-665" />
              </div>)}
          </div>
        </div>
        <div className="h-64 w-full" data-id="element-666">
          <svg viewBox="0 0 1000 400" className="w-full h-full" preserveAspectRatio="xMidYMid meet" data-id="element-667">
            {/* Grid lines */}
            {[0, 1, 2, 3, 4, 5, 6, 7, 8].map(i => <line key={`h-${i}`} x1="50" y1={50 * i} x2="950" y2={50 * i} stroke="#e5e7eb" strokeWidth="1" data-id="element-668" />)}
            {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(i => <line key={`v-${i}`} x1={50 + i * 90} y1="0" x2={50 + i * 90} y2="400" stroke="#e5e7eb" strokeWidth="1" data-id="element-669" />)}
            {/* X-axis labels */}
            {trendData.map((point, i) => <text key={`x-${i}`} x={50 + i * 128.5 + 64.25} y="395" textAnchor="middle" className="text-[10px] font-bold fill-gray-500" data-id="element-670">
                {point.date}
              </text>)}
            {/* Y-axis labels */}
            {[0, 100, 200, 300, 400, 500, 600, 700, 800].map((value, i) => <text key={`y-${i}`} x="35" y={400 - value / 2} textAnchor="end" className="text-[10px] font-bold fill-gray-500" data-id="element-671">
                {value}
              </text>)}
            {/* Lines */}
            <polyline points={trendData.map((point, i) => `${50 + i * 128.5 + 64.25},${400 - point.item1 / 2}`).join(' ')} fill="none" stroke="#2563eb" strokeWidth="2" data-id="element-672" />
            <polyline points={trendData.map((point, i) => `${50 + i * 128.5 + 64.25},${400 - point.item2 / 2}`).join(' ')} fill="none" stroke="#dc2626" strokeWidth="2" data-id="element-673" />
          </svg>
        </div>
      </div>
    </div>;
};
export default PlayerStats;